/* Import TinyMCE */
import './tinymce';

/* Default icons are required for TinyMCE 5.3 or above */
import './icons/default/icons';

/* A theme is also required */
import './themes/silver/theme';

/* Import the skin */
import './skins/ui/oxide/skin.css';

/* Import plugins */
import './plugins/advlist/plugin';
import './plugins/code/plugin';
import './plugins/emoticons/plugin';
import './plugins/emoticons/js/emojis';
import './plugins/link/plugin';
import './plugins/lists/plugin';
import './plugins/table/plugin';

import './models/dom/model';

/* Import premium plugins */
/* NOTE: Download separately and add these to /src/plugins */
/* import './plugins/checklist/plugin'; */
/* import './plugins/powerpaste/plugin'; */
/* import './plugins/powerpaste/js/wordimport'; */

/* Import content css */
// import './skins/ui/oxide/skin.css';
// import './skins/ui/oxide/content.css';
// import './skins/content/default/content.css';

window.tinymce = tinymce;